import React, { useContext } from "react";

import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";

function ContactCardpatent({ preview, HColor = "#E1FF8B", Iconcolor, Textcolor, BtIColor }) {
  const [cardData] = useContext(CardContext);

  const {
    personalDetails,
    vCard,
    contactDetails,
    Hcolor,
    phoneNumbers,
    emailList,
  } = cardData;

  const iconBg = Iconcolor ? Iconcolor : cardData?.Iconcolor ? cardData?.Iconcolor : cardData?.Highlightcolor ? cardData?.Highlightcolor : "#E1FF8B";
  const textColor = Textcolor ? Textcolor : cardData?.Textcolor ? cardData?.Textcolor : "#000000";
  const btIColor = BtIColor ? BtIColor : cardData?.BtIColor ? cardData?.BtIColor : "#D2F470";
  // const { personalDetails, Hcolor, contactDetails } = useSelector(
  //   (state) => state.cardReducer
  // );
  // const Highlightcolor = Hcolor.hex ? Hcolor?.hex : "";
  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  return (
    <>
      <div
        className="p-1"
        style={{
          backgroundColor: HColor,
          borderTopLeftRadius: "36px",
          borderTopRightRadius: "0px",
          borderBottomRightRadius: "36px",
          borderBottomLeftRadius: "36px",
        }}
      >
        <div className="grid gap-5 grid-cols-2 mt-[10px] items-center justify-start">
          <div className="  flex items-center gap-1 p-2 justify-start ">
            <div>
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.0400391"
                  y="0.848633"
                  width="38"
                  height="38"
                  rx="19"
                  fill={iconBg}
                />
                <path
                  d="M25.5369 27.3486C23.9569 27.3486 22.3369 26.953 20.6769 26.1618C19.0169 25.3699 17.475 24.2589 16.0513 22.8289C14.6263 21.3983 13.5182 19.8561 12.7269 18.2024C11.9357 16.5486 11.54 14.9318 11.54 13.3518C11.54 13.0655 11.6338 12.8271 11.8213 12.6364C12.0088 12.4446 12.2432 12.3486 12.5244 12.3486H14.8429C15.0979 12.3486 15.3204 12.4289 15.5104 12.5896C15.7004 12.7502 15.8288 12.9558 15.8957 13.2064L16.3607 15.4424C16.4044 15.7049 16.3966 15.9339 16.3372 16.1296C16.2785 16.3252 16.1747 16.4855 16.026 16.6105L13.9682 18.5286C14.3532 19.2274 14.7785 19.8761 15.2441 20.4749C15.7097 21.0743 16.2066 21.6421 16.7347 22.1783C17.2785 22.7221 17.8641 23.2283 18.4916 23.6971C19.1191 24.1652 19.8079 24.6071 20.5579 25.0227L22.5632 22.9818C22.7157 22.8174 22.8872 22.7089 23.0779 22.6564C23.2685 22.6046 23.4791 22.5943 23.7097 22.6255L25.6822 23.0286C25.9366 23.0911 26.1432 23.2193 26.3019 23.413C26.4607 23.6074 26.54 23.8302 26.54 24.0814V26.3643C26.54 26.6455 26.4444 26.8799 26.2532 27.0674C26.0625 27.2549 25.8232 27.3486 25.5369 27.3486ZM13.5275 17.6493L15.3275 15.9936C15.3875 15.9461 15.4263 15.8802 15.4438 15.7958C15.4625 15.7114 15.4594 15.6333 15.4344 15.5614L15.0191 13.5739C14.9947 13.4783 14.9525 13.4064 14.8925 13.3583C14.8325 13.3102 14.7547 13.2861 14.6591 13.2861H12.7354C12.6635 13.2861 12.6035 13.3102 12.5554 13.3583C12.5072 13.4064 12.4832 13.4664 12.4832 13.5383C12.5013 14.1789 12.6013 14.8477 12.7832 15.5446C12.9663 16.2421 13.2138 16.9436 13.5275 17.6493ZM21.4504 25.4624C22.0841 25.7761 22.7591 26.0083 23.4754 26.1589C24.1929 26.3089 24.8179 26.3893 25.3504 26.3999C25.4222 26.3999 25.4822 26.3761 25.5304 26.3286C25.5785 26.2805 25.6025 26.2202 25.6025 26.1477V24.2661C25.6025 24.1699 25.5785 24.0918 25.5304 24.0318C25.4822 23.9711 25.4104 23.9289 25.3147 23.9052L23.5804 23.5499C23.5079 23.5261 23.4444 23.523 23.39 23.5405C23.3363 23.5593 23.2794 23.5983 23.2194 23.6577L21.4504 25.4624Z"
                  fill={btIColor}
                />
              </svg>
            </div>
            <div className="text-[14px] flex flex-col">
            {personalDetails?.phone &&
              <Link
                className="text-[14px] font-semibold flex justify-left items-center overflow-auto scrollbar-hide"
                style={{ color: textColor }}
                to={preview ? `tel:+${personalDetails?.phone}` : ""}
              >
                +
                {personalDetails?.phone
                  ? personalDetails.phone
                  : "123 456 7890"}
              </Link>
}
              {personalDetails?.secondaryPhone && (
                <Link
                  className="text-[14px] font-semibold flex justify-left items-center"
                  style={{ color: textColor }}
                  to={preview ? `tel:+${personalDetails?.secondaryPhone}` : ""}
                >
                  +
                  {personalDetails?.secondaryPhone
                    ? personalDetails.secondaryPhone
                    : "123 456 7890"}
                </Link>
              )}
                {/* ----------------- NEW PHONE NUMBER------------ */}
                <div className="flex flex-col gap-2 mt-2">
                    {phoneNumbers?.map((phone) => {
                      return (
                        <div
                          className={`flex ${
                            phone?.alignCol && phone?.showLabel
                              ? "flex-col gap-1 items-center" // Added items-center for column layout
                              : !phone?.alignCol && phone?.showLabel
                              ? "flex-row gap-1 justify-center"
                              : !phone?.alignCol && phone?.showLabel
                              ? "flex-row gap-1 justify-center "
                              : "flex-row gap-1 justify-center "
                          }`}
                        >
                          {phone?.showLabel && (
                            <label className="font-semibold" style={{ color: textColor }}>
                              {phone?.label}
                            </label>
                          )}
                          <p className="text-[14px] font-semibold" style={{ color: textColor }}>
                            +{phone?.number}
                          </p>
                        </div>
                      );
                    })}
            </div>
            </div>
          </div>
          <div className="  p-2 flex items-center gap-2 justify-start">
            <div>
              <svg
                width="39"
                height="40"
                viewBox="0 0 39 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.959961"
                  y="0.848633"
                  width="38"
                  height="38.6071"
                  rx="19"
                  fill={iconBg}
                />
                <path
                  d="M12.895 18.6026C12.895 14.1849 16.2489 11.3486 19.9599 11.3486C23.6708 11.3486 27.0247 14.1849 27.0247 18.6026C27.0247 19.9768 26.4946 21.5179 25.3709 23.238C24.2482 24.9565 22.551 26.8255 20.2643 28.8453C20.0934 28.9926 19.8356 28.9926 19.6647 28.8452C17.3733 26.8253 15.6737 24.9563 14.5498 23.2378C13.425 21.5178 12.895 19.9768 12.895 18.6026ZM17.5686 18.4135C17.5686 19.7298 18.6435 20.8047 19.9599 20.8047C21.2762 20.8047 22.3511 19.7298 22.3511 18.4135C22.3511 17.0972 21.2762 16.0223 19.9599 16.0223C18.6435 16.0223 17.5686 17.0972 17.5686 18.4135Z"
                  stroke={btIColor}
                />
              </svg>
            </div>
            <div>
              <p className="text-[14px] font-medium pt-3  w-[80px] flex items-center scrollbar-hide overflow-auto text-start" style={{ color: textColor }}>
                {contactDetails?.address
                  ? contactDetails.address
                  : "2709 Hwy 51, Janesville"}
              </p>
            </div>
          </div>
        </div>

        <div className=" mt-[0px]  flex items-center gap-1 pl-2 pb-2 justify-start ">
          <div className=" flex items-center justify-center">
            <div className="flex  gap-2 justify-start items-center">
              <div>
                <svg
                  width="39"
                  height="39"
                  viewBox="0 0 39 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.0400391"
                    y="0.455757"
                    width="38"
                    height="38"
                    rx="19"
                    fill={iconBg}
                  />
                  <path
                    d="M26.1994 17.3363L19.5372 21.2565C19.3866 21.3453 19.2149 21.3922 19.04 21.3922C18.8652 21.3922 18.6935 21.3454 18.5429 21.2565L18.5432 21.2568L18.7968 20.8259L18.5428 21.2565L26.1994 17.3363ZM26.1994 17.3363V23.2855C26.1994 23.7877 25.9999 24.2693 25.6448 24.6244C25.2897 24.9795 24.808 25.179 24.3058 25.179H13.7742C13.272 25.179 12.7903 24.9795 12.4352 24.6244C12.0801 24.2693 11.8806 23.7877 11.8806 23.2855V17.3363M24.3058 13.7325L24.3059 13.7325C24.7718 13.7324 25.2214 13.9041 25.5687 14.2148C25.8375 14.4552 26.0303 14.7658 26.1277 15.1086L19.04 19.2778L11.9523 15.1086C12.0497 14.7658 12.2426 14.4552 12.5113 14.2148C12.8586 13.9041 13.3082 13.7324 13.7741 13.7325H13.7742L24.3058 13.7325Z"
                    stroke={btIColor}
                  />
                </svg>
              </div>
              <div className=" ">
                <p className="text-[14px] flex-col font-medium  flex items-center text-center overflow-auto w-[200px] scrollbar-hide" style={{ color: textColor }}>
                  {personalDetails?.email && 
                  <Link onClick={preview ? shareMail : ""}>
                    {personalDetails?.email
                      ? personalDetails.email
                      : "john@example.com"}
                  </Link>
                  }
                  {personalDetails?.secondaryEmail &&
                  <div className="mt-2">
                    <Link onClick={preview ? shareMail2 : ""}>
                      {personalDetails?.secondaryEmail
                        ? personalDetails.secondaryEmail
                        : ""}
                    </Link>
                  </div>
}
                    {/* ----------------- NEW PHONE NUMBER------------ */}
                    <div className="flex flex-col gap-2 mt-2">
                    {emailList?.map((email) => {
                      return (
                        <div
                          className={`flex ${
                            email?.alignCol && email?.showLabel
                              ? "flex-col gap-1 items-center" // Added items-center for column layout
                              : !email?.alignCol && email?.showLabel
                              ? "flex-row gap-1 justify-center"
                              : !email?.alignCol && email?.showLabel
                              ? "flex-row gap-1 justify-center "
                              : "flex-row gap-1 justify-center "
                          }`}
                        >
                          {email?.showLabel && (
                            <label className="font-semibold" style={{ color: textColor }}>
                              {email?.label}
                            </label>
                          )}
                          <p className="text-[14px] font-semibold" style={{ color: textColor }}>
                            +{email?.email}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div></div>
    </>
  );
}

export default ContactCardpatent;
